import React, { useEffect, useState } from 'react'
import { connectWallet } from '../utils'
import { isUserAdmin } from '../data'
import Breakpoint, {
  BreakpointProvider,
  setDefaultBreakpoints,
} from 'react-socks'
import { Link } from '@reach/router'


setDefaultBreakpoints([{ xs: 0 }, { l: 1199 }, { xl: 1200 }])

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? 'active' : 'non-active',
      }
    }}
  />
)

function getReturnUrl() {
  return window.location.pathname==="/"?"/":"/admin"
}

const Header = function () {

  const [showmenu, btn_icon] = useState(false)
  const [isAdm, setIsAdm] = useState(false)



  const isAdmin = async () => {
    const response = await isUserAdmin() 
    if(response){
      setIsAdm(response)
      return response
    }else{
      setIsAdm(response)
      return response
    }
    
  }

  const IsAdmin = () => {
    if(isAdm){
      return (
        <NavLink to="/admin" onClick={() => btn_icon(!showmenu)}>
          Admin 
          <span className="lines"></span>
        </NavLink>
      );
    }else{
      return(
        <NavLink to="/admin" style={{display:"none"}} onClick={() => btn_icon(!showmenu)}>
          Admin 
          <span className="lines"></span>
        </NavLink>
      )
    }

  }

  useEffect(() => {
    const header = document.getElementById('myHeader')
    const totop = document.getElementById('scroll-to-top')
    const sticky = header.offsetTop
    const scrollCallBack = window.addEventListener('scroll', () => {
      btn_icon(false)
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky')
        totop.classList.add('show')
      } else {
        header.classList.remove('sticky')
        totop.classList.remove('show')
      }
      
    })
    return () => {
      window.removeEventListener('scroll', scrollCallBack)
    }
  }, [])
  useEffect(() => {
    isAdmin()
  })
  return (
    <header id="myHeader" className="navbar white">
      <div className="container">
        <div className="row w-100-nav">
          <div className="logo px-0">
            <div className="navbar-title navbar-item">
              <NavLink to="/">
                <img
                  src="./img/logo-3.png"
                  className="img-fluid d-block"
                  alt="#"
                />
                <img src="./img/logo-3.png" className="img-fluid d-3" alt="#" />
                <img
                  src="./img/logo-light.png"
                  className="img-fluid d-none"
                  alt="#"
                />
              </NavLink>
            </div>
          </div>

          <div className="search">
            <input
              id="quick_search"
              className="xs-hide"
              name="quick_search"
              placeholder="search item here..."
              type="text"
            />
          </div>

          <BreakpointProvider>
            <Breakpoint l down>
              {showmenu && (
                <div className="menu">
                  <div className="navbar-item">
                    <NavLink to="/" onClick={() => btn_icon(!showmenu)}>
                      Home
                      <span className="lines"></span>
                    </NavLink>
                  </div>
                        <div className="navbar-item">
                        <NavLink to="/admin" onClick={() => btn_icon(!showmenu)}>
                          Admin
                          <span className="lines"></span>
                        </NavLink>
                      </div>
                </div>
              )}
            </Breakpoint>

            <Breakpoint xl>
              <div className="menu">
                <div className="navbar-item">
                  <NavLink to="/" onClick={() => btn_icon(!showmenu)}>
                    Home
                    <span className="lines"></span>
                  </NavLink>
                </div>
                    <div className="navbar-item">
                    <IsAdmin/>
                  </div>
              </div>
            </Breakpoint>
          </BreakpointProvider>

          <div className="mainside">
            <NavLink to={getReturnUrl()} onClick={ async () => 
              {
                let result = await connectWallet()
                alert(result.status)
                }} className="btn-main">
              Connect Wallet
            </NavLink>
          </div>
        </div>

        <button className="nav-icon" onClick={() => btn_icon(!showmenu)}>
          <div className="menu-line white"></div>
          <div className="menu-line1 white"></div>
          <div className="menu-line2 white"></div>
        </button>
      </div>
    </header>
  )
}
export default Header
